import $ from "jquery";


export default function module_side_navigation() {
    $('.avu-services-template-nav-mobile').on('click', function(e) {
        if($('.avu-services-template #flush-collapseTemplate').hasClass('show')) {
            $('.avu-services-template #flush-collapseTemplate').removeClass('show');
        }
        if(!$('.avu-services-template .accordion-button').hasClass('collapsed')) {
            $('.avu-services-template .accordion-button').addClass('collapsed');
        }
        if($('.avu-services-template-container #flush-collapseTemplate').hasClass('show')) {
            $('.avu-services-template-container #flush-collapseTemplate').removeClass('show');
        }
        if(!$('.avu-services-template-container .accordion-button').hasClass('collapsed')) {
            $('.avu-services-template-container .accordion-button').addClass('collapsed');
        }
    });

    $('.avu-services-link').on('click', function(e) {
        e.preventDefault();

        let target = $(this).attr('href');
        let offset;
        if(window.innerWidth > 992) {
            offset = $(target).offset().top - 280;
        } else {
            offset = $(target).offset().top - 200;
        }


        $('html, body').animate({
            scrollTop: offset
        }, 0);

    });

     let $window = $(window);
        let isScrolling = true;

        function isElementInViewport($element) {
            let windowHeight = $window.height();
            let windowTop = $window.scrollTop();
            let elementTop = $element.offset().top;
            let elementHeight = $element.outerHeight();
            let elementCenter;
            if(window.innerWidth > 390) {
                elementCenter = (elementTop + elementHeight / 2);
            } else {
                elementCenter = elementTop;
            }


            return elementCenter >= windowTop && elementCenter <= (windowTop + windowHeight);
        }

        $('.avu-services-template-posts .avu-services-post').each(function() {
            let $container = $(this);
            if (isElementInViewport($container)) {
                let $element = $container.find('h2');
                let elementId = $element.attr('id');
                let hyperlink = '#'+elementId;
                let link =  $('a[href="'+hyperlink+'"]');
                $('.avu-services-link').removeClass('highlight');
                link.addClass('highlight');
            }
        });

       $window.scroll(function(){
            if (isScrolling == true) {
                $('.avu-services-template-posts .avu-services-post').each(function () {
                    let $container = $(this);
                    if (isElementInViewport($container)) {
                        let $element = $container.find('h2');
                        let elementId = $element.attr('id');
                        let hyperlink = '#' + elementId;
                        let link = $('a[href="' + hyperlink + '"]');
                        $('.avu-services-link').removeClass('highlight');
                        link.addClass('highlight');
                    }
                });
            }
            //$('.avu-services-template #flush-collapseTemplate').removeClass('show');
            //$('.avu-services-template .accordion-button').addClass('collapsed');
            //$('.avu-services-template-container #flush-collapseTemplate').removeClass('show');
            //$('.avu-services-template-container .accordion-button').addClass('collapsed');

        });
    /* $('.avu-services-template .avu-services-link').click(function(e) {
          e.preventDefault();
          let targetId = $(this).attr('href');
          if (targetId) {
              let targetElement = $(targetId);
              if (targetElement.length) {
                  $('html, body').animate({
                      scrollTop: targetElement.offset().top - 150
                  }, 0);
              }
          }
          isScrolling = false;
          $('.avu-services-link').removeClass('highlight');
          $(this).addClass('highlight');
          setTimeout(function() {
              isScrolling = true;
          }, 0);
      });

      $('.avu-single-magazin .avu-services-link').click(function(e) {
          e.preventDefault();
          let targetId = $(this).attr('href');
          if (targetId) {
              let targetElement = $(targetId);
              if (targetElement.length) {
                  $('html, body').animate({
                      scrollTop: targetElement.offset().top - 200
                  }, 0);
              }
          }
          isScrolling = false;
          $('.avu-services-link').removeClass('highlight');
          $(this).addClass('highlight');
          setTimeout(function() {
              isScrolling = true;
          }, 0);
      });*/
}